import React, { useState, useRef } from 'react';
import './VideoCard.css';
import VideoHeader from "./VideoHeader"
import VideoFooter from './VideoFooter';


function VideoCard({url, likes, shares, channel, avatarSrc, song}) {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  console.log(url);
  const videoRef = useRef(null);

  const onVideoPress = () => {
    if (isVideoPlaying){
      //stop
      videoRef.current.pause();
      setIsVideoPlaying(false);
    }
    else {
      //play
      videoRef.current.play();
      setIsVideoPlaying(true);
    }
  };
  // https://www.instagram.flhr3-2.fna.fbcdn.net/v/t50.2886-16/117598442_205338364335864_545695080903278566_n.mp4?_nc_ht=instagram.flhr3-2.fna.fbcdn.net&_nc_cat=100&_nc_ohc=vjDPPklLnOYAX-xOjlv&oe=5F38FACF&oh=fbe19a529394ac8cc1a61f1b2b016e54

  return (<div className='videoCard'>
  <VideoHeader />
  
  <iframe 
  title={url}
  className='videoCard__player'
  ref={videoRef}
  onClick={onVideoPress}
  src ={url}
  alt='ig-reel-video'
  type="video/mp4"
  loop /> 
  
  
  
  
  <VideoFooter 
    channel={channel}
    avatarSrc={avatarSrc}
    song={song}
    likes={likes}
    shares={shares}
  />
  </div>)
}

export default VideoCard;
